import React, { useContext } from 'react';
import Button from '@atlaskit/button';
import EditorRemoveIcon from '@atlaskit/icon/glyph/editor/remove';
import Tooltip from '@atlaskit/tooltip';
import styled from '@emotion/styled';
import { GlobalContext } from '../../shared-components/common/GlobalContext';
import { CutIfTooBig } from './CutIfTooBig';
import { token } from '@atlaskit/tokens';
import { UNKNOWN_USER_DISPLAYNAME_PLACEHOLDER_DTO } from '../../generated-common';

export class SelectValueLabel {
  // https://react-select.com/home
  constructor(
    public value: any,
    public label: any,
    public avatar: string | null,
    public displayName: string
  ) {}
}
const UserName = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 6px;
`;
const Wrap = styled.div<{ isDisabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'inherit')};
`;
export const UserWithAvatar = ({
  user,
  index,
  onDelete,
  isReadOnly,
  isDisabled,
  parentWidth,
}: {
  user: SelectValueLabel;
  index: number;
  onDelete: (index: number, value: SelectValueLabel) => void;
  isReadOnly: boolean;
  isDisabled: boolean;
  parentWidth: number | undefined;
}) => {
  const { t } = useContext(GlobalContext);
  return (
    <>
      {user && (
        <Wrap isDisabled={isDisabled}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {user.avatar ? (
              <img src={user.avatar} style={{ width: '30px', height: '30px', borderRadius: '50%', marginRight: '10px' }} alt=" " />
            ) : (
              <svg
                viewBox="0 0 64 64"
                style={{ width: '30px', height: '30px', marginRight: '10px' }}
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                strokeLinejoin="round"
                strokeMiterlimit="1.414"
              >
                <circle cx="32.408" cy="33.392" r="28.185" fill="#c5c5c5" transform="matrix(1.10046 0 0 1.09987 -3.664 -4.726)" />
                <g transform="translate(-8.61 1.746) scale(3.38413)" fill="#fff">
                  <path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006l-.008 1.857s-2.144 2.289-5.983 2.315c-3.571.023-5.995-2.299-5.995-2.299L6 14z" />
                  <circle cx="12" cy="7" r="4" />
                </g>
              </svg>
            )}
            <UserName>
              <CutIfTooBig
                color={token('color.text.subtlest', '#ccc')}
                maxWidth={parentWidth ? parentWidth - 40 - 50 : undefined}
                tooltipText={user.displayName === UNKNOWN_USER_DISPLAYNAME_PLACEHOLDER_DTO ? 'unknown' : user.displayName}
                text={
                  <>
                    <span
                      style={{
                        color: isDisabled
                          ? token('color.text.subtlest', '#ccc')
                          : user.displayName === '?NO_USER_FOUND?'
                            ? token('color.text.danger', '#ff0000')
                            : token('color.text.accent.blue.bolder', '#253858'),
                      }}
                    >
                      {user.displayName === UNKNOWN_USER_DISPLAYNAME_PLACEHOLDER_DTO ? (
                        <span style={{ color: token('color.text.subtlest', '#ccc'), fontStyle: 'italic' }}>unknown user</span>
                      ) : (
                        user.displayName
                      )}
                    </span>
                    {/*<span style={{ paddingLeft: '10px', color: '#ccc' }}>{user.value}</span>*/}
                  </>
                }
              />
            </UserName>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {isReadOnly === false && (
              <Tooltip content={t('global.permission.remove')}>
                <Button
                  isDisabled={isDisabled}
                  appearance="subtle"
                  onClick={() => onDelete(index, user)}
                  iconBefore={<EditorRemoveIcon label="delete" primaryColor={isDisabled ? token('color.text.disabled', '#ccc') : token('color.text.accent.blue.bolder', '#253858')} />}
                />
              </Tooltip>
            )}
          </div>
        </Wrap>
      )}
    </>
  );
};
